module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /Users/nw/motion/js-deps/~/babel-runtime/core-js/array/from.js
 ** module id = 297
 ** module chunks = 1
 **/